module.exports = __webpack_public_path__ + "assets/img/37_382.082d6286.jpg";